<template>
  <div>
    <div class="mianContent" v-if="isShow == 1">
      <div
        class="dataPng huancun"
        :style="{ backgroundImage: 'url(' + huancun + ')' }"
      ></div>
      <div class="bot">
        <p>
          <b>（{{ codeText }}s）</b> 正在获取认证状态，请稍后···
        </p>
      </div>
    </div>
    <div class="mianContent" v-if="isShow == 0">
      <div
        class="dataPng huancun"
        :style="{ backgroundImage: 'url(' + Issuccess + ')' }"
      ></div>
      <div class="bot bot1">
        <p>您的人脸识别已认证成功</p>
        <p>请关闭手机，回到电脑上继续操作</p>
      </div>
    </div>
    <div class="mianContent" v-if="isShow == 2">
      <div
        class="dataPng huancun errorImg"
        :style="{ backgroundImage: 'url(' + Iserror + ')' }"
      ></div>
      <div class="bot bot1">
        <p>您已取消人脸识别认证</p>
        <p>请关闭手机，回到电脑上继续操作</p>
      </div>
    </div>
    <div class="mianContent" v-if="isShow == 3">
      <div
        class="dataPng huancun errorImg"
        :style="{ backgroundImage: 'url(' + Iserror + ')' }"
      ></div>
      <div class="bot bot1">
        <p>当前人脸识别人信息与企业法人信息不一致</p>
        <p>请重新扫码进行认证</p>
      </div>
    </div>
    <div class="mianContent" v-if="isShow == 4">
      <div
        class="dataPng huancun errorImg"
        :style="{ backgroundImage: 'url(' + Iserror + ')' }"
      ></div>
      <div class="bot bot1">
        <p>当前人脸识别人信息与账号实名信息不一致</p>
        <p>请重新扫码进行认证</p>
      </div>
    </div>
    <div class="mianContent" v-if="isShow ==5">
      <div
        class="dataPng huancun errorImg"
        :style="{ backgroundImage: 'url(' + Iserror + ')' }"
      ></div>
      <div class="bot bot1">
        <p style="line-height:1.5">为保护您的账户安全，<br>仅支持认证为原实名主体</p>
        <!-- <p>请重新扫码进行认证</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { faceStatus } from "@http/user_center/faceIdent";

export default {
  name: "",
  data() {
    return {
      isShow: 3, // 0 成功 1 继续 2失败
      huancun: require("@/assets/images/huancun.gif"),
      Issuccess: require("@/assets/images/success.png"),
      Iserror: require("@/assets/images/enterError.png"),
      errorMsg: "", //错误信息
      timer: null, //秒表
      httptime: null, //5秒请求定时
      codeText: 30, //倒计时时间
      times: 6, //请求次数
    };
  },
  created() {
    this.init();
  },
  destroyed() {
    clearInterval(this.timer, this.httptime);
  },

  methods: {
    async initStatus(bizToken) {
      let res = faceStatus(bizToken);
      if (res && res.code === 1) {
        this.init();
      } else if (res && res.code === 0) {
        _this.isShow = 0;
        clearInterval(this.timer, this.httptime);
      } else if (res && res.code === 2) {
        this.errorMsg = res.message;
        _this.isShow = 2;
        clearInterval(this.timer, this.httptime);
      }else if(res && res.code === 5){
        _this.isShow = 5;
      }
    },
    init() {
      let _this = this;
      let { code, bizToken } = _this.$route.query;
      // code: 0 成功 1 继续回调 5秒调用一次 6次直接失败 2 直接失败显示原因
      if (code == 0) {
        _this.isShow = 0;
        clearInterval(_this.timer, _this.httptime);
      } else if (code == 1) {
        _this.isShow = 1;

        _this.timer = setInterval(() => {
          _this.codeText--;
          if (_this.codeText == 0) clearInterval(_this.timer);
        }, 1000);

        _this.httptime = setInterval(() => {
          _this.initStatus({ bizToken });
          _this.times--;
          // 6次直接失败
          if (_this.times == 0) {
            clearInterval(_this.httptime);
            _this.isShow = 2;
          }
        }, 5000);
      } else if (code == 2) {
        _this.isShow = 2;
        this.initStatus({ bizToken });
        clearInterval(_this.timer, _this.httptime);
      }else if(code==3){
         _this.isShow = 3;
      }else if(code==4){
         _this.isShow = 4;
      }else if(code==5){
         _this.isShow = 5;
      }
      
    },
  },
};
</script>

<style scoped lang='less'>
.dataPng {
  width: 130px;
  height: 130px;
  margin: 30px auto;
  background-size: cover;
  margin-top: 10%;
}
.bot {
  text-align: center;
  font-size: 19px;
}
.errorImg {
  width: 160px;
}
.bot1 {
  p {
    font-weight: bold;
    &:nth-child(2) {
      color: #888888;
      font-size: 17px;
      margin-top: 5px;
    }
  }
}
</style>
